import { AlertOutlined } from '@ant-design/icons-vue'
export default [
  {
    path: '/alarm',
    name: 'alarm',
    redirect: '/alarm/template',
    meta: {
      title: '告警管理',
      sort: 3,
      icon: AlertOutlined,
      isFullScreen: false,
      keepAlive: true,
      prem: true,
    },
    children: [
      {
        path: '/alarm/template',
        name: 'alarmTemplate',
        component: () => import('@/views/alarm/template/index.vue'),
        meta: { title: '告警模板', sort: 1, isFullScreen: false, keepAlive: true, prem: true },
      },
      {
        path: '/alarm/plan',
        name: 'alarmPlan',
        component: () => import('@/views/alarm/plan/index.vue'),
        meta: {
          title: '告警计划',
          sort: 2,
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
      {
        path: '/alarm/history',
        name: 'alarmHistory',
        component: () => import('@/views/alarm/history/index.vue'),
        meta: {
          title: '告警历史',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/telephone/config',
        name: 'telephoneConfig',
        component: () => import('@/views/alarm/telephoneConfig/index.vue'),
        meta: {
          title: '外呼配置',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/alarm/tenantTemplate',
        name: 'alarmTenantTemplate',
        component: () => import('@/views/alarm/tenantTemplate/index.vue'),
        meta: {
          title: '租户告警模版',
          sort: 4,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/alarm/deviceRiskRule',
        name: 'alarmDeviceRiskRule',
        component: () => import('@/views/alarm/deviceRiskRule/index.vue'),
        meta: {
          title: '设备风险规则',
          sort: 5,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/alarm/fallReviewStrategy',
        name: 'alarmFallReviewStrategy',
        component: () => import('@/views/alarm/fallReviewStrategy/index.vue'),
        meta: {
          title: '跌倒复核策略',
          sort: 6,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
